import { useState, useEffect } from 'react'
import Section from './_Section'
import { createMarkup } from '../../helpers/markup'
import ButtonEl from '../helpers/ctas/Button'
import Image from '../helpers/Image'
import TitleBlock from '../helpers/TitleBlock'
import { transformPaddingToTailwind } from '../../helpers/style'

function InformationBanner(props) {
  const [textAlignment, setTextAlignment] = useState({
    flex: 'center',
    align: 'center',
  })
  const componentPadding = transformPaddingToTailwind(props.componentPadding)

  useEffect(() => {
    setTextAlignment((prevState) => {
      const newState = { ...prevState }
      const alignment = props.contentAlignment?.toLowerCase() ?? 'center'
      if (newState.align !== props.contentAlignment?.toLowerCase()) {
        newState.flex = alignment === 'center' ? 'center' : 'start'
        newState.align = alignment === 'center' ? 'center' : 'left'
      }
      return newState
    })
  }, [])

  return (
    <Section
      type="informationBanner"
      outerClass={componentPadding}
      sectionTitle={false}
      innerClass={`px-7 text-${textAlignment.align}`}
      {...props}
      mobileBackgroundImage={props.mobileImage}
      desktopBackgroundImage={props.desktopImage}
    >
      <Image {...props.image} className="mx-auto mb-7" />
      {(props.title || props.description) && <TitleBlock {...props} />}

      {props.ctaLink.length != 0 && (
        <div className={`flex justify-${textAlignment.flex}  space-x-6 mt-10`}>
          {props.ctaLink.map((ctaLinkItem, i) => (
            <ButtonEl
              key={i}
              link={ctaLinkItem.link}
              icon={ctaLinkItem.linkIconClass}
              theme={ctaLinkItem.linkType.toLowerCase()}
            />
          ))}
        </div>
      )}
    </Section>
  )
}

export default InformationBanner
